import React, { useState, useEffect } from 'react';
import FacultyNavbar from './FacultyNavbar';
import '../styles/StudentsDriveDetails.css';

const StudentsDriveDetails = () => {
  const [driveDetails, setDriveDetails] = useState([]);

  useEffect(() => {
    const fetchDriveDetails = async () => {
      try {
        const response = await fetch('https://backend-main-4.onrender.com/students-drive-details');
        const data = await response.json();
        setDriveDetails(data);
      } catch (error) {
        console.error('Error fetching drive details:', error);
      }
    };

    fetchDriveDetails();
  }, []);

  return (
    <div>
      <FacultyNavbar />
      <div className="container mt-5">
        <h2 className="text-center">Students Drive Details</h2>
        <div className="drive-details">
          {driveDetails.length > 0 ? (
            driveDetails.map((detail, index) => (
              <div key={index} className="drive-detail">
                <h3>{detail.companyName}</h3>
                <p>Date: {detail.date}</p>
                <p>Location: {detail.location}</p>
                <p>Eligibility: {detail.eligibility}</p>
                <p>Contact: {detail.contact}</p>
              </div>
            ))
          ) : (
            <p>No drive details available.</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default StudentsDriveDetails;
